// src/slice/taskSchedulerSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import  {axiosClientSignIn} from '../axios/api.js'


export const fetchScheduledEvents = createAsyncThunk(
  'taskScheduler/fetchScheduledEvents',
  async (_, thunkAPI) => {
    const res = await axiosClientSignIn.get('/scheduled-events');
    console.log(res.data,"/scheduled-events'/scheduled-events'/scheduled-events'")
    return res.data;
  }
);

export const createScheduledEvent = createAsyncThunk(
  'taskScheduler/createScheduledEvent',
  async (eventData, { rejectWithValue }) => {
    try {
      const res = await axiosClientSignIn.post('/scheduled-events/createScheduledEvent', eventData);
      return res.data;
    } catch (err) {
      if (err.response && err.response.data) {
        // Send backend error message to payload
        return rejectWithValue(err.response.data);
      } else {
        // Generic fallback
        return rejectWithValue({ message: err.message });
      }
    }
  }
);

export const updateScheduledEvent = createAsyncThunk(
  'taskScheduler/updateScheduledEvent',
  async ({ id, updates }, thunkAPI) => {
    const res = await axiosClientSignIn.put(`/scheduled-events/${id}`, updates);
    return res.data;
  }
);
export const createEvent = createAsyncThunk(
  'taskScheduler/Event',
  async (eventData, { rejectWithValue }) => {
    try {
      const res = await axiosClientSignIn.post('/scheduled-events/createEvent', eventData);
      return res.data;
    } catch (err) {
      if (err.response && err.response.data) {
        // Send backend error message to payload
        return rejectWithValue(err.response.data);
      } else {
        // Generic fallback
        return rejectWithValue({ message: err.message });
      }
    }
  }
);


export const createDirectEvent = createAsyncThunk(
  'taskScheduler/createDirectEvent',
  async (eventData, { rejectWithValue }) => {
    try {
        console.log(eventData)
      const res = await axiosClientSignIn.post('/scheduled-events/createDirectEvent', eventData);
      return res.data;
    } catch (err) {
      if (err.response && err.response.data) {
        // Send backend error message to payload
        return rejectWithValue(err.response.data);
      } else {
        // Generic fallback
        return rejectWithValue({ message: err.message });
      }
    }
  }
);

export const deleteScheduledEvent = createAsyncThunk(
  'taskScheduler/deleteScheduledEvent',
  async (id, thunkAPI) => {
   const data = await axiosClientSignIn.post(`/scheduled-events/${id}`);
    console.log(data,  'taskScheduler/deleteScheduledEvent')
    return id;
  }
);

export const deleteEvent = createAsyncThunk(
  'taskScheduler/deleteEvent',
  async (id, thunkAPI) => {
    await axiosClientSignIn.post(`/scheduled-events/${id}`);
    return id;
  }
);

export const updateEvent = createAsyncThunk(
  'taskScheduler/updateEvent',
  async ({ id, updates }, thunkAPI) => {
    const res = await axiosClientSignIn.put(`/scheduled-events/${id}`, updates);
    return res.data;
  }
);


export const fetchEvents = createAsyncThunk(
  'taskScheduler/fetchEvents',
  async (_, thunkAPI) => {
    const res = await axiosClientSignIn.get('/scheduled-events/event');
    console.log('taskScheduler/fetchEventstaskScheduler/fetchEventstaskScheduler/fetchEventstaskScheduler/fetchEventstaskScheduler/fetchEventstaskScheduler/fetchEventstaskScheduler/fetchEvents')
    console.log(res.data)
    return res.data;
  }
);


export const fetchEventsCompleted = createAsyncThunk(
  'taskScheduler/fetchEventsCompleted',
  async (_, thunkAPI) => {
    const res = await axiosClientSignIn.get('/scheduled-events/getEventsCompleted');
    console.log(res.data)
    return res.data;
  }
);


export const unscheduleEvent = createAsyncThunk(
  'taskScheduler/unscheduleEvent',
  async (id, { rejectWithValue }) => {
    try {
      await axiosClientSignIn.delete(`/scheduled-events/unschedule/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message });
    }
  }
);

export const fetchDirectEventsCompleted = createAsyncThunk(
  'taskScheduler/fetchDirectEventsCompleted',
  async (_, thunkAPI) => {
    const res = await axiosClientSignIn.get('/scheduled-events/getDirectEventsCompleted');
    console.log(res.data)
    return res.data;
  }
);


export const updateDirectEvent = createAsyncThunk(
  'taskScheduler/updateEvent',
  async ({ id, updates }, thunkAPI) => {
    const res = await axiosClientSignIn.put(`/scheduled-events/updateDirectEvent/${id}`, updates);
    return res.data;
  }
);


const taskSchedulerSlice = createSlice({
  name: 'taskScheduler',
  initialState: {
    events: [],
    pure_events:[],
    archive:[],
    loading: false,
    error: null,
  },
  reducers: {
    addLocalEvent: (state, action) => {
      // state.events.push(action.payload);
    },
    removeLocalEvent: (state, action) => {
      // state.events = state.events.filter(e => e._id !== action.payload);
    },
    removeWaitlistEvent: (state, action) => {
      // state.pure_events = state.pure_events.filter(e => e._id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder

      // 🔄 Fetch
      .addCase(fetchEvents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEvents.fulfilled, (state, action) => {
  state.loading = false;
   
      console.log(action.payload)
  state.pure_events = action.payload.filter(event => !event.isCompleted);
})

      .addCase(fetchEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
        

        .addCase(fetchEventsCompleted.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEventsCompleted.fulfilled, (state, action) => {
  state.loading = false;
  
  state.archive = action.payload.filter(event =>  event.status === "Completed");
})

      .addCase(fetchEventsCompleted.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
           .addCase(fetchScheduledEvents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
     .addCase(fetchScheduledEvents.fulfilled, (state, action) => {
  state.loading = false;
  state.events = action.payload.filter(event => event.status !== "completed" && event.isCompleted !==true );
})

      .addCase(fetchScheduledEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // ➕ Create

    // 👇 Triggered when API call starts
    .addCase(createScheduledEvent.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    // 👇 Triggered when API call succeeds
    .addCase(createScheduledEvent.fulfilled, (state, action) => {
      state.loading = false;
      const newEvent = action.payload;

      // If payload is valid, push into events
      // if (newEvent) {
      //   state.events.push(newEvent);
      // }
    })

    // 👇 Triggered when API call fails
    .addCase(createScheduledEvent.rejected, (state, action) => {
      state.loading = false;
       console.log(action.payload)
      // action.payload exists only if rejectWithValue is used
      if (action.payload && typeof action.payload === 'object') {
        state.error = action.payload.message || 'Unknown error';
      } else {
        // fallback: use generic error
        state.error = action.error?.message || 'Request failed';
      }
    })



      // ✏️ Update
      .addCase(updateScheduledEvent.fulfilled, (state, action) => {
        // const index = state.events.findIndex(e => e._id === action.payload._id);
        // if (index !== -1) {
        //   state.events[index] = action.payload;
        // }
      })

      // ❌ Delete
      .addCase(deleteScheduledEvent.fulfilled, (state, action) => {
        // state.events = state.events.filter(e => e._id !== action.payload);
      })
      .addCase(unscheduleEvent.fulfilled, (state, action) => {
        state.events = state.events.filter(e => e._id !== action.payload);
      })
      .addCase(deleteEvent.fulfilled, (state, action) => {
        // state.pure_events = state.pure_events.filter(e => e._id !== action.payload);
      })
      .addCase(updateEvent.fulfilled, (state, action) => {
        // const index = state.pure_events.findIndex(e => e._id === action.payload._id);
        // if (index !== -1) {
        //   state.pure_events[index] = action.payload;
        // }
      })

      // ➕ Create Direct Event (Recurring/Meeting)
      .addCase(createDirectEvent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDirectEvent.fulfilled, (state, action) => {
        state.loading = false;
        console.log('Direct Event created:', action.payload);
        // The backend returns both directEvents and scheduledEvents
        // No need to update state here as we'll refetch with fetchEvents
      })
      .addCase(createDirectEvent.rejected, (state, action) => {
        state.loading = false;
        console.log('Create Direct Event failed:', action.payload);
        if (action.payload && typeof action.payload === 'object') {
          state.error = action.payload.message || action.payload.error || 'Unknown error';
        } else {
          state.error = action.error?.message || 'Failed to create direct event';
        }
      })
.addCase(updateDirectEvent.pending, (state) => {
  state.loading = true;
})


  },
});

export const { addLocalEvent, removeLocalEvent, removeWaitlistEvent } = taskSchedulerSlice.actions;
export default taskSchedulerSlice.reducer;
